<template>
  <el-select
    v-model="selectedValue"
    :placeholder="placeholder"
    :disabled="isDisabled"
    :clearable="isClearable"
    :multiple="multiple"
    :filterable="filterable"
    style="width: 100%"
  >
    <el-option
      v-for="(item, idx) in options"
      :key="idx"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>
<script>

export default {
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    isDisabled() {
      return this.disabled;
    },
    isClearable() {
      return this.clearable;
    },
  },
};
</script>
